// extracted by mini-css-extract-plugin
export default {"toolbar":"Toolbar-module-toolbar-4f6b0af8f42abbc020629946f9759e11"};